import Login from "../Login/Login";
import { Navigate, Route, Routes } from "react-router-dom";
import AdminLayout from "../Router/AdminLayout";
import Dashboard from "../pages/Dashboard/Dashboard";
import AuthorListing from "../pages/Author/AuthorListing";
import Category from "../pages/category/Category";
import Tags from "../pages/tags/Tags";
import BlogListing from "../pages/blogs/BlogListing";
import AddBlog from "../pages/blogs/AddBlog";
import EditBlog from "../pages/blogs/EditBlog";
import Contact from "../pages/Contact/Contact";
import SeoListing from "../pages/Seo/SeoListing";
import SeoCreate from "../pages/Seo/SeoCreate";
import SeoEdit from "../pages/Seo/SeoEdit";
import Newsletter from "../pages/Newsletter/Newsletter";
import HomeContact from "../pages/HomeContact/HomeContact";
import EditClientLogo from "../pages/clientLogos/EditClientLogo";
import ClientLogos from "../pages/clientLogos/ClientLogos";
import AddClientLogo from "../pages/clientLogos/AddClientLogo";
import Stats from "../pages/stats/Stats";
// import SubCategoryListing from "../pages/LogisticsIndustriesService/SubCategory/SubCategoryListing";
import LogisticsCategory from "../pages/LogisticsIndustriesService/Category/LogisticsCategory";
import LogiststicIndustries from "../pages/LogisticsIndustriesService/LogisticsService/LogiststicIndustries";
import AddLogisticsService from "../pages/LogisticsIndustriesService/LogisticsService/AddLogisticsService";
import EditLogisticsService from "../pages/LogisticsIndustriesService/LogisticsService/EditLogisticsService";
import CalculatorListing from "../pages/calculator/CalculatorListing";
import AddCalculator from "../pages/calculator/AddCalculator";
import EditCalculator from "../pages/calculator/EditCalculator";
import AdminPrice from "../pages/pricing/AdminPrice";
import AddPrice from "../pages/pricing/AddPrice";
import EditPrice from "../pages/pricing/EditPrice";
import FeatureCategory from "../pages/Feature/FeatureCategory/FeatureCategory";
import AddFeature from "../pages/Feature/FeatureService/AddFeature";
import FeatureService from "../pages/Feature/FeatureService/FeatureService";
import EditFeature from "../pages/Feature/FeatureService/EditFeature";
import DynamicListing from "../pages/DynamicPage/DynamicListing";
import AddDynamic from "../pages/DynamicPage/AddDynamic";
import EditDynamic from "../pages/DynamicPage/EditDynamic";
import Industry from "../pages/caseStudyModule/caseIndustry/Industry";
import CaseStudy from "../pages/caseStudyModule/caseStudies/CaseStudy";
import AddCase from "../pages/caseStudyModule/caseStudies/AddCase";
import EditCase from "../pages/caseStudyModule/caseStudies/EditCase";
import TmsIntegrationCategory from "../pages/TmsIntegration/Category/TmsIntegrationCategory";
import TmsIntegrationListing from "../pages/TmsIntegration/Integration/TmsIntegrationListing";
import AddTmsIntegration from "../pages/TmsIntegration/Integration/AddTmsIntegration";
import EditTmsIntegration from "../pages/TmsIntegration/Integration/EditTmsIntegration";
import FaqListing from "../pages/Faq/FaqListing";
import AddFaq from "../pages/Faq/AddFaq";
import EditFaq from "../pages/Faq/EditFaq";
import SchemaManagement from "../pages/schema-management/SchemaManagement";
import SitemapEditor from "../pages/sitemap/SitemapEditor";
import LlmsManagement from "../pages/Llms/LlmsManagement";
import RobotsManagement from "../pages/Robots/RobotsManagement";
import NewsListing from "../pages/News/NewsListing";
import NewsCreate from "../pages/News/NewsCreate";
import NewsEdit from "../pages/News/NewsEdit";
import NewsCategory from "../pages/NewsCategory/NewsCategory";
import ComparisonListing from "../pages/comparison/ComparisonListing";
import AddComparison from "../pages/comparison/AddComparison";
import EditComparison from "../pages/comparison/EditComparison";
import EmailManagement from "../pages/EmailManagement/EmailManagement";
import AddEmailManagement from "../pages/EmailManagement/AddEmailManagement";
import EditEmailManagement from "../pages/EmailManagement/EditEmailManagement";
import Users from "../pages/Rbac/Users";
import Roles from "../pages/Rbac/Roles";
import Permissions from "../pages/Rbac/Permissions";


export default function Router() {
  return (
    <>
      <Routes>
        <Route path={"login"} element={<Login />} />
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="author" element={<AuthorListing />} />
          <Route path="category" element={<Category />} />
          <Route path="tag" element={<Tags />} />
          <Route path="blog" element={<BlogListing />} />
          <Route path="add-blog" element={<AddBlog />} />
          <Route path="edit-blog/:blog_id" element={<EditBlog />} />
          <Route path="news" element={<NewsListing />} />
          <Route path="add-news" element={<NewsCreate />} />
          <Route path="edit-news/:news_id" element={<NewsEdit />} />
          <Route path="news-category" element={<NewsCategory />} />
          <Route path="comparison-page" element={<ComparisonListing />} />
          <Route path="add-comparison" element={<AddComparison />} />
          <Route path="edit-comparison/:comparison_id" element={<EditComparison />} />
          <Route path="tms-integration-category" element={<TmsIntegrationCategory />} />
          <Route path="tms-integration" element={<TmsIntegrationListing />} />
          <Route path="add-tms-integration" element={<AddTmsIntegration />} />
          <Route path="edit-tms-integration/:integration_id" element={<EditTmsIntegration />} />
          <Route path="contact" element={<Contact/>} />
          <Route path="seo" element={<SeoListing/>} />
          <Route path="global-seo" element={<SchemaManagement/>} />
          <Route path="schema-management" element={<Navigate to="/global-seo" replace />} />
          <Route path="sitemap" element={<SitemapEditor/>} />
          <Route path="llms" element={<LlmsManagement/>} />
          <Route path="robots" element={<RobotsManagement/>} />
          <Route path="add-seo" element={<SeoCreate/>} />
          <Route path="edit-seo/:seo_id" element={<SeoEdit/>} />
          <Route path="newsletter" element={<Newsletter/>} />
          <Route path="email-management" element={<EmailManagement/>} />
          <Route path="add-email-management" element={<AddEmailManagement/>} />
          <Route path="edit-email-management/:dynamicemail_id" element={<EditEmailManagement/>} />
          <Route path="users" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          <Route path="permissions" element={<Permissions />} />
          <Route path="home-contact" element={<HomeContact/>} />
          <Route path="stats" element={<Stats/>} />

          <Route path="calculator" element={<CalculatorListing />} />
          <Route path="add-calculator" element={<AddCalculator />} />
          <Route path="edit-calculator/:roicalculator_id" element={<EditCalculator />} />

          {/* Case Study */}
          <Route path="industry" element={<Industry />} />
          <Route path="case-study" element={<CaseStudy />} />
          <Route path="add-case-study" element={<AddCase />} />
          <Route path="edit-case-study/:case_id" element={<EditCase />} />


        {/* logistics */}
          {/* <Route path="logistic-subcategory" element={<SubCategoryListing />} /> */}
          <Route path="logistic-category" element={<LogisticsCategory />} />
          <Route path="logistic" element={<LogiststicIndustries />} />
          <Route path="add-logistics" element={<AddLogisticsService />} />
          <Route path="edit-logistics/:logistics_id" element={<EditLogisticsService />} />


          {/* Feature */}
          <Route path="feature-category" element={<FeatureCategory />} />
          <Route path="add-feature" element={<AddFeature />} />
          <Route path="feature-service" element={<FeatureService />} />
           <Route path="edit-feature/:feature_id" element={<EditFeature />} />

          <Route path="price" element={<AdminPrice />} />
          <Route path="add-price" element={<AddPrice />} />
          <Route path="edit-price/:price_id" element={<EditPrice />} />

          <Route path="client-logos" element={<ClientLogos />} />
          <Route path="add-client-logo" element={<AddClientLogo />} />
          <Route path="edit-client-logo/:clientlogo_id" element={<EditClientLogo />} />

          <Route path="dynamic" element={<DynamicListing />} />
          <Route path="add-dynamic" element={<AddDynamic />} />
          <Route path="edit-dynamic/:service_id" element={<EditDynamic />} />
          <Route path="faq" element={<FaqListing />} />
          <Route path="add-faq" element={<AddFaq />} />
          <Route path="edit-faq/:faq_id" element={<EditFaq />} />
        </Route>
      </Routes>
    </>
  )
}
